import React from 'react';
import { availableLanguages } from '../i18n';
import { useLang } from '../i18n';

const LanguageDropdown: React.FC = () => {
  const { lang, setLang } = useLang();

  return (
    <div style={{ position: 'relative' }}>
      <select
        value={lang}
        onChange={(e) => setLang(e.target.value as any)}
        style={{ fontSize: '1.2rem', padding: '6px 10px', borderRadius: 8 }}
        aria-label="Select language"
      >
        {availableLanguages.map(l => (
          <option key={l.code} value={l.code}>{l.flag} {l.label}</option>
        ))}
      </select>
    </div>
  );
};

export default LanguageDropdown;
